<template>
  <div class="flex h-full">
    <h4 class="mr-8 flex items-center justify-center uppercase font-semibold">
      Contratos
    </h4>
    <router-link
      v-for="(menu, k) in options"
      v-bind:key="k"
      tag="span"
      :to="menu.path"
      class="
        cursor-pointer
        h-full
        p-2
        mx-2
        flex
        items-center
        justify-center
        -mb-2
      "
      exact-active-class="active"
      @click.native="$emit('clicked')"
    >
      <i :class="`el-icon-fa-${menu.icon} mr-2`"></i>
      {{ menu.name }}
    </router-link>
  </div>
</template>

<script>
import { checkPermissions } from "../../utils";

export default {
  name: "ContactSubMenu",
  data() {
    return {
      contratosMenu: [
        {
          icon: "plus",
          path: "/contracts/new",
          name: "Nueva contratación",
          submodule: "Todos",
        },
        {
          icon: "list-ul",
          path: "/contracts/all",
          name: "Contratos en proceso",
          submodule: "Nuevo",
        },
      ],
    };
  },
  computed: {
    options() {
      return this.contratosMenu.filter(
        (item) =>
          this.$store.getters.isSuper ||
          checkPermissions(`Contratos:${item.submodule}`, "Page:view") ||
          checkPermissions(`Contratos:${item.submodule}`, "Page:viewOwn")
      );
    },
  },
};
</script>
